const result = {
  validation_errors: {},
  validation_has_error: false,
  validation_message: [
    {
      message: "Invalid Form! Please complete the fields"
    }
  ]
};
const CustomValidation = (validations, values) => {
  result.validation_has_error = false;
  result.validation_message = [
    {
      message: "Invalid Form! Please complete the fields"
    }
  ];
  result.validation_errors = {};
  let aKeys = Object.keys(validations).sort();
  let bKeys = Object.keys(values).sort();
  aKeys = aKeys.filter(value => -1 !== bKeys.indexOf(value));
  bKeys = bKeys.filter(value => -1 !== aKeys.indexOf(value));
  const total = bKeys.length ? bKeys.length : 0;

  // console.log(bKeys)
  // console.log(aKeys)
  // console.log(aKeys.filter(value => -1 !== bKeys.indexOf(value)))

  for (let i = 0; i < total; i++) {
    // console.log(validations[aKeys[i]])
    // console.log(values)
    // console.log(values[bKeys[i]])
    const valueB =
      typeof values[bKeys[i]] === "undefined" ? "" : values[bKeys[i]];
    if (aKeys[i] === bKeys[i]) {
      // console.log(bKeys[i].size)
      // console.log(aKeys[i])
      if (typeof valueB.size === "undefined") {
        // REQUIRED
        if (validations[aKeys[i]].required) {
          if (!valueB.trim().length) {
            result.validation_has_error = true;
            result.validation_errors[bKeys[i]] =
              (validations[aKeys[i]].usename
                ? validations[aKeys[i]].usename
                : bKeys[i]) + " is required";
          }
        }

        // MIN LENGTH
        if (valueB.trim().length && validations[aKeys[i]].minLength) {
          if (valueB.trim().length < validations[aKeys[i]].minLength) {
            result.validation_has_error = true;
            result.validation_errors[bKeys[i]] =
              (validations[aKeys[i]].usename
                ? validations[aKeys[i]].usename
                : bKeys[i]) +
              " is too short at least more than or equal to " +
              validations[aKeys[i]].minLength +
              " characters";
          }
        }

        // MAX LENGTH
        if (valueB.trim().length && validations[aKeys[i]].maxLength) {
          if (valueB.trim().length > validations[aKeys[i]].maxLength) {
            result.validation_has_error = true;
            result.validation_errors[bKeys[i]] =
              (validations[aKeys[i]].usename
                ? validations[aKeys[i]].usename
                : bKeys[i]) +
              " is too long at least less than or equal to " +
              validations[aKeys[i]].maxLength +
              " characters";
          }
        }

        // EMAIL
        if (valueB.trim().length && validations[aKeys[i]].email) {
          const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!re.test(valueB)) {
            result.validation_has_error = true;
            result.validation_errors[bKeys[i]] =
              (validations[aKeys[i]].usename
                ? validations[aKeys[i]].usename
                : bKeys[i]) + " is not a valid email";
          }
        }

        // CONFIRM VALUE
        if (
          validations[aKeys[i]].confirm &&
          validations[aKeys[i]].confirm_value
        ) {
          // console.log(validations[aKeys[i]].confirm_value);
          if (valueB !== validations[aKeys[i]].confirm_value) {
            result.validation_has_error = true;
            result.validation_errors[bKeys[i]] =
              (validations[aKeys[i]].usename
                ? validations[aKeys[i]].usename
                : bKeys[i]) + " not match";
          }
        }
      }
    }
  }
  return result;
};
export default CustomValidation;
